{"name": "evse-web", "buildversion": "1.0.13_SNAPSHOT_10132026-125941", "buildTime": "13/10/2026 12:59:52"}